// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-popup {
    position: fixed;
    z-index: 1000;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
}

.modal-popup .modal-popup-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.modal-popup .modal-popup-content {
    position: relative;
    margin: 15% auto;
    padding: 32px 20px;
    width: 80%;
    max-width: 600px;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.5);
    text-align: center;
}

.modal-popup .modal-popup-content button {
    margin: 20px 10px 0 10px;
}`, "",{"version":3,"sources":["webpack://./src/ModalPopup/ModalPopup.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;IACb,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B","sourcesContent":[".modal-popup {\n    position: fixed;\n    z-index: 1000;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    background-color: rgba(0, 0, 0, 0.4);\n}\n\n.modal-popup .modal-popup-background {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.modal-popup .modal-popup-content {\n    position: relative;\n    margin: 15% auto;\n    padding: 32px 20px;\n    width: 80%;\n    max-width: 600px;\n    background-color: #fff;\n    border-radius: 5px;\n    box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.5);\n    text-align: center;\n}\n\n.modal-popup .modal-popup-content button {\n    margin: 20px 10px 0 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
